import { PostModel } from "common/models/baseModel";

import { useQuery } from "@tanstack/react-query";
import { ICourseGridFilter } from "./types";
import { course } from "./query";

export function useListQuery(model: PostModel<ICourseGridFilter>) {
  return useQuery(course.list(model));
}

export function useGetQuery(id: number) {
  return useQuery({
    ...course.get(id),
    enabled: id > 0,
  });
}

export function useViewQuery(id: number, isOpen: boolean) {
  return useQuery({
    ...course.view(id),
    enabled: id > 0 && isOpen,
  });
}

export function useCourseValuesQuery() {
  return useQuery(course.courseValues);
}
